import React, { useContext, useEffect, useState } from "react";
import intl from "react-intl-universal";
import { UserContext } from "../Contexts/User";
import { locales } from "../Utils";

const Translations = ({ children }) => {
  const [stateUserContext] = useContext(UserContext);
  const [locale, setLocale] = useState(null);

  useEffect(() => {
    let newLanguage = "pt-BR";

    if (window.navigator.language && locales[window.navigator.language]) {
      newLanguage = window.navigator.language;
    }

    if (stateUserContext.userLanguage) {
      newLanguage = stateUserContext.userLanguage;
    }

    intl
      .init({
        locales,
        fallbackLocale: "pt-BR",
        currentLocale: newLanguage,
      })
      .then(() => {
        setLocale(newLanguage);
      });
  }, [stateUserContext.userLanguage]);

  if (!locale) {
    return null;
  }

  return <React.Fragment key={locale}>{children}</React.Fragment>;
};

export default Translations;
